angular.module('bmsApp.trugreen.job').controller('TGJobMainCtrl',
	function ($state,
			  $scope) {

		$scope.$on('jobIndexUpdated', function (e, jobData) {
			$scope.jobData = jobData;
		});

        $scope.$on("CloseJobListSideData", function (e, visitData) {
            $scope.visitData = visitData;
        });

		$scope.$on("closeJobUpdated", function (e, data) {
			$scope.closeJobData = data;
		});

		$scope.exportJobs = function () {
			$scope.$broadcast('tgJobIndexExport', {});
			console.log('tgJobIndexExport');
		};

	});
